export default {
    layout: {
        loading: 'İşlem Devam Ediyor',
        trading: 'İşlem Devam Ediyor'
    },
    footer: {
    },
    menu: {
        home: 'Ana Sayfa',
        staking: 'Matris',
        port: 'PORT',
        internet: 'Ağ',
        me: 'Benim'
    },
    header: {
        selectLang: 'Dil Seç',
        close: 'Kapat',
        trading: 'Ticaret',
        dashboard: 'Kontrol Paneli',
        subscribeMatrix: 'Matris Aboneliği',
        portTaskCenter: 'PORT Görev Merkezi',
        network: 'Ağ',
        apiBinding: 'API Bağlama',
        gridTree: 'Izgara Ağacı',
        account: 'Hesap',
        documents: 'Belgeler ve Whitepaper',
        personalCenter: 'Kişisel Merkez',
        language: 'Dil'
    },
    home: {
        recently1:'Topluluk',
        staticrewares: 'Statik',
        recentlyName: 'Defter',
        recentlyInfo: 'Gelir Detayları',
        dataUpdate: 'Veri Güncelleme',
        realtime: 'Gerçek Zaman · BSC',
        totalRevenue: 'Toplam Gelir (USDT)',
        today: 'Bugün',
        totalTradingVolume: 'Toplam İşlem Hacmi',
        todayEarn: 'Bugün Kazanç',
        share: 'Arkadaşlarla Paylaş',
        shareDesc: 'Gelirini göster, davet et ve ödül kazan',
        directReferrals: 'Doğrudan Referanslar',
        teamMembers: 'Takım Üyeleri',
        thisWeek: 'Bu Hafta',
        copy: 'Kopyala',
        recently: 'Son Gelir',
        netIncome: 'Net Gelir',
        dailyAverage: 'Günlük Ortalama',
        quantitativeIncome: 'Kuantum Gelir',
        recommend: 'Tavsiye',
        port: 'PORT',
        bonus: 'Bonus',
        all: 'Tümü',
        todayTitle: 'Bugün',
        loadingMore: 'Daha Fazla Yükle',
        recommendBonus: 'Referans Bonusu',
        portTaskPassed: 'PORT Görevi Tamamlandı',
        myProfit: 'Benim Karım',
        earningOnBitDeep: 'BitDeep Üzerinde Kazanç',
        totalRevenueUsdt: 'Toplam Gelir · USDT',
        consecutiveDays: 'Ardışık Günler',
        scanToJoin: 'Katılmak için Tara',
        uid: 'UID',
        referralBonus: 'Referans Bonusu',
        shareTo: 'Şuraya Paylaş',
        eachReferral: 'Paylaşım Bonusu',
        screenshotAndShare: 'Ekran Görüntüsü Al ve Paylaş',
        saveShareEarn: 'Kaydet · Paylaş · Kazan',
        period: 'Dönem',
        netProfit: 'Net Kar',
        quantReward: 'Kuantum Ödül',
        dailyBonus: 'PORT Günlük Bonus',
        close: 'Kapat',
        permission: 'İzin',
        onlyEnable: 'Sadece Etkinleştir',
        enterBitgetUid: 'BITGET UID Girin',
        slogan: 'Parola',
        document: 'Belge',
        days: 'Gün',
        taskText: 'Görev',
        minutes: 'Dakika',
        decentralizedPortTech: 'Merkezsiz PoRT teknik mimarisi, BGB token ekonomisi ve çift bölge teşvik matrisi.',
        auditReport: 'Denetim Raporu',
        faqSupport: 'SSS & Destek',
        telegram: 'Telegram',
        piece: 'Parça',
        faq: 'SSS',
       faq1: 'Bitget API nasıl bağlanır?',
        faq1Desc: 'Bitget Borsası → Ayarlar → API Yönetimi yoluyla API Key ve Secret edinin. Yalnızca Spot İşlem iznini etkinleştirin; çekim iznini kesinlikle etkinleştirmeyin. Anahtarları BitDeep DApp\'e yapıştırın. 1 USDT\'lik test işlemini tamamladığınızda bağlama etkinleşir.',
        faq2: 'PoRT (Gerçek İşlem Kanıtı) nedir?',
        faq2Desc: 'PoRT, "işlem = madencilik" yaklaşımının çekirdek mekanizmasıdır. Sistem her gün Bitget API üzerinden belirlenen bir coinde (örn. BGB) otomatik hızlı al-sat işlemleri yapar. İşlem hacmi Stake × %50\'yi aştığında doğrulama sonrası günlük ödül tetiklenir.',
        faq3: 'Her gün manuel olarak izlemem gerekiyor mu?',
        faq3Desc: 'Hayır. API bağlandıktan sonra sistem 24 saatlik pencerede işlem görevini otomatik olarak tamamlar. Manuel işlem gerekmez; PoRT menüsünden kontrol edebilirsiniz.',
        faq4: 'ALPHA ile SIGMA arasındaki fark nedir?',
        faq4Desc: 'ALPHA (Başlangıç): 500 USDT stake, %0.3–1.3 günlük getiri, yalnızca 1 paket. SIGMA (Pro): 1.000 USDT stake, %0.6–1.6 günlük getiri, en fazla 5 paket.',
        faq5: 'Param güvende mi? Platform paralarıma dokunabilir mi?',
        faq5Desc: 'Fonlarınız %100 kendi Bitget hesabınızda kalır. API yalnızca okuma ve spot işlem izinleri verir; sistem ana parayı çekemez veya transfer edemez.',
        faq6: 'Günlük kazançlar ne zaman ödenir?',
        faq6Desc: 'PoRT doğrulaması başarılı olduktan sonra ödeme bir sonraki gün gerçekleşir. Sistem hem USDT kazancını hem de 10x Deep puanlarını otomatik olarak verir — çift ödül.',
        faq7: 'Scout Bonus (Doğrudan Referans Ödülü) nasıl hesaplanır?',
        faq7Desc: 'Doğrudan davet ettiğin her aktif hesap için sabit günlük ödül kazanırsın: ALPHA (500 USDT) referansı için 1 USDT/gün, SIGMA (1.000 USDT) referansı için 2 USDT/gün; o hesabın döngüsü bitene kadar ödenir.',
        faq8: 'Seviye nasıl yükseltilir (D1–D7)?',
        faq8Desc: 'Küçük bölge (zayıf bacak) toplam cirosuna göre seviye yükseltirsiniz. Örneğin: D1 için 2.000 USDT, D3 için 15.000 USDT, en üst D7 için 3.000.000 USDT gerekir. Seviye yükseldikçe seviye farkı ödülleri artar (D7\'de en fazla 7 USDT/kişi/gün).',
        faq9: 'Bir döngü kaç gün? Süresi bittiğinde ne olur?',
        faq9Desc: 'Bir döngü 28 gündür. Döngü bittikten sonra stake\'e devam etmeyi seçebilirsiniz; ödüller, günlük gerçek PoRT doğrulama sonuçlarına göre değişken olarak ödenir.',
        faq10: 'Çekim ücreti var mı?',
        faq10Desc:'Çekimler 0 ücretlidir. Platform çekim ücretlerini havuza yönlendirerek LP likiditesini güçlendirir ve erdemli bir döngü oluşturur.',
        bigArea: 'Büyük Bölge',
        smallArea: 'Küçük Bölge',
        enterWithdrawAmount: 'Çekim Miktarını Girin',
        all: 'Tümü',
        available: 'Mevcut',
        totalAmount: 'Toplam Tutar',
        confirmWithdraw: 'Çekimi Onayla',
        withdrawRecord: 'Çekim Kaydı',
        withdrawn: 'Çekildi',
        quickStartGuide:'Hızlı Başlangıç Kılavuzu',
        whitepaperGuide:'Whitepaper & Kılavuz',
        whitepaper:'Whitepaper',
        downloadPdf:'İndir'
    },
    staking: {
        selectPackage: 'Matris Aboneliği',
        alpha: 'ALPHA',
        beginner: 'Başlangıç',
        sigma: 'SIGMA',
        professional: 'Profesyonel',
        popular: 'En Popüler',
        dailyReturn: 'Görev Ödülleri',
        teamDepth: 'Takım Derinliği',
        limitPurchase: 'Satın Alma Limiti',
        layer: 'Katman',
        copy: 'Parça',
        autoRenew: 'Otomatik Yenileme',
        autoReinvest: 'Otomatik Yenileme Marjı',
        subscribeAlpha: 'Alpha Aboneliği',
        subscribeSigma: 'Sigma Aboneliği',
        stakedAmount: 'Teminat',
        stakedAmount2: 'Dönem',
        stakedAmount3: 'Toplam Gelir',
        stakingTime: 'Katılım Süresi',
        maturityTime: 'Vade Süresi',
        redeem: 'Çöz',
        renew: 'Yenile',
        autoRenewActive: 'Otomatik Yenileme Aktif',
        autoRenewInactive: 'Otomatik Yenileme Pasif',
        smartContract: 'Akıllı sözleşme yönetimi, Teminat 28 gün boyunca kilitlenir ve vade sonunda açılır.',
        alter2:'Eğer taahhüdünüzün süresi dolmuşsa, lütfen yenileyin.',
    },
    me: {
        account: 'Hesap',
        my: 'Benim',
        staked: 'Katıldı edildi',
        staked1: 'Teminat',
        points: 'Puanlar',
        consecutive: 'Ardışık günler',
        withdraw: 'Çekim',
        language: 'Dil',
        simplifiedChinese: 'Basitleştirilmiş Çince',
        disconnectWallet: 'Cüzdanı ayır',
        level: 'Seviye',
        joinDate: 'Katılma tarihi',
        bdId: 'BD-ID'
    },
    bindapi: {
        apiBinding: 'API Bağlama',
        bindDesc: 'Borsa API anahtarınızı bağlayarak kuantum ticaretine izin verin',
        apiKey: 'API Anahtarı',
        apiSecret: 'API Gizli Anahtarı',
        exchange: 'Borsa',
        futures: 'Vadeli İşlemler',
        spot: 'Spot',
        readOnly: 'Sadece Okuma',
        bind: 'Bağla',
        riskNote: 'API anahtarı yalnızca ticaret verilerini senkronize etmek için kullanılır, hassas bilgiler saklanmaz',
        apiConnection: 'API Bağlantısı',
        bindExchangeApi: 'Borsa API’sini Bağla',
        bitDeepRead: 'BitDeep, CEX hesabınızın emir akışını okuyarak gerçek ticaret kanıtını doğrular (PoRT).',
        noWithdraw: 'Çekimlerinize asla dokunmayız.',
        securityTip: 'Güvenlik İpucu · Lütfen dikkatlice okuyun',
        close: 'Kapat',
        withdraw: 'Çekim',
        permission: 'İzin',
        onlyEnable: 'Sadece Etkinleştir',
        spotTrading: 'Spot Ticaret',
        read: 'Oku',
        recommendedPartner: 'Önerilen Ortak',
        zeroFee: '0% Komisyon',
        activated: 'Aktif',
        classicAccount: 'Klasik Hesap',
        unifiedAccount: 'Birleşik Hesap',
        bindBitgetApi: 'Bitget API Bağla',
        upcoming: 'Yakında',
        underAudit: 'Denetimde',
        expected: 'Bekleniyor'
    },
    port: {
    portTaskCenter: 'PORT Görev Merkezi',
    dailyTask: 'Günlük Görev',
    verify: 'Doğrula',
    completed: 'Tamamlandı',
    incomplete: 'Tamamlanmadı',
    verifyStandard: 'Doğrulama Standardı',
    tradingVolume: 'İşlem Hacmi',
    today: 'Bugün',
    deadline: 'Son Tarih',
    reward: 'Ödül',
    startVerify: 'Doğrulamayı Başlat',
    verifying: 'Doğrulanıyor',
    verified: 'Doğrulandı',
    insufficient: 'Yetersiz',
    viewDetails: 'Detayları Gör',
    taskList: 'Görev Listesi',
    allTasks: 'Tüm Görevler',
    completedTasks: 'Tamamlandı',
    pendingTasks: 'Beklemede',
    proofOfRealTrading: 'Gerçek Ticaret Kanıtı',
    todayTask: 'Bugünkü Görev',
    todayStaticIncome: 'Bugünkü Görev Ödülleri',
    points: 'Puanlar',
    todayWindowClosesAt: 'Bugünkü Pencere Kapanış Saati',
    checkTaskStatus: 'Görev Durumunu Kontrol Et',
    teamProgress: 'Takım İlerlemesi · Bugün',
    realtimePortCompletion: 'Gerçek Zamanlı PORT Tamamlama',
    completedText: 'Tamamlandı',
    pendingText: 'Beklemede',
    realtimeApiValidationFlow: 'Gerçek Zamanlı · API · Doğrulama Akışı',
    rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
},
internet: {
    network: 'Ağ',
    treeBrowser: 'Ağaç Tarayıcı',
    searchAddress: '0x... adresi veya BD-ID ara',
    totalTradingVolume: 'Toplam İşlem Hacmi',
    members: 'Üyeler',
    networkStructure: 'Ağ Yapısı',
    allLevels: 'Tüm Seviyeler',
    addRemark: 'Not Ekle',
    enterRemark: 'Lütfen Not Girin',
    cancel: 'İptal',
    confirm: 'Onayla',
    alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
},
withdraw: {
    withdraw: 'Çekim',
    usdtAsset: 'USDT Varlığı',
    withdrawAmount: 'Çekim Miktarı',
    availableBalance: 'Kullanılabilir Bakiye',
    fee: 'Ücret',
    actualArrival: 'Gerçek Geliş',
    submit: 'Gönder',
    withdrawSuccess: 'Çekim Başarılı',
    withdrawFailed: 'Çekim Başarısız',
    processing: 'İşleniyor',
    completed: 'Tamamlandı',
    withdrawHistory: 'Çekim Geçmişi'
},
popup: {
    taskUnfinished: 'Görev Tamamlanmadı',
    taskUnfinishedDesc: 'İşlem verileri bugünkü PoRT doğrulama standardına ulaşmadı',
    todayTradingVolume: 'Bugünkü İşlem Hacmi',
    remaining: 'Kalan',
    toComplete: 'Bugünkü görevi tamamlamak için',
    tradingVolumeThreshold: '',
    deadline: 'Görev bitimine kalan süre',
    tryAgain: 'Daha Sonra Tekrar Dene',
    goTrade: 'Ticarete Git',
    taskCompleted: 'Görev Doğrulandı',
    taskCompletedDesc: 'Bugünkü PoRT ticaret kanıtı başarıyla blok zincirine kaydedildi',
    rewardIssued: 'Ödül Verildi',
    complete: 'Tamamlandı',
    shareTitle: 'Paylaşım Daveti',
    shareDesc: 'Arkadaşlarını davet et, her iki taraf da ödül kazanır',
    referralLink: 'Davet Linki',
    qrCode: 'QR Kod',
    copyLink: 'Linki Kopyala',
    notask:'Bugün görev yok',
    notaskDesc:'Şu anda bekleyen PoRT işlem görevleri bulunmuyor',
}
}